import React, { useState } from 'react';
import { PriorNegotiation } from '@indigo-ag/schema';
import i18next from 'core/i18n';
import { Button, palettes } from '@indigo-ag/component-module';
import { faChevronUp, faChevronDown } from '@fortawesome/pro-regular-svg-icons';

import { createStylesHook } from 'shared';
import { Contract } from '../Contract/Contract';

const useStyles = createStylesHook({
  title: {
    margin: '24px 0',
    fontSize: '20px',
    'font-weight': '500'
  },
  seeMore: {
    alignSelf: 'flex-end',
    color: palettes.brand.blue.dark,
    width: 'fit-content'
  }
});

interface Props {
  priorNegotiations: PriorNegotiation[];
  hideRowsAfter?: number;
  title: string;
}

export const ContractList: React.FunctionComponent<Props> = ({ priorNegotiations, hideRowsAfter = 3, title }) => {
  /**
   * Styles
   */
  const classes = useStyles();

  /**
   * State
   */
  const [isListExpanded, setIsListExpanded] = useState(false);

  const toggleExpandContracts = () => setIsListExpanded(!isListExpanded);

  return (
    <>
      <div className={classes.title}>{title}</div>
      {priorNegotiations
        .slice(0, isListExpanded ? priorNegotiations?.length : hideRowsAfter)
        .map((priorNegotiation, index) => (
          <Contract key={index} priorNegotiation={priorNegotiation} />
        ))}
      {priorNegotiations.length > hideRowsAfter && (
        <Button
          variant="tertiary"
          onClick={toggleExpandContracts}
          faIconAfter={isListExpanded ? faChevronUp : faChevronDown}
          className={classes.seeMore}
        >
          {i18next.t(`${isListExpanded ? 'seeLess' : 'seeMore'}`)}
        </Button>
      )}
    </>
  );
};
